import { defineMessages } from 'react-intl';

export const messages: {
	dateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datePlaceholder: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	timeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timePlaceholder: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	dateLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.edit.date-label',
		defaultMessage: 'Date : {label}',
		description:
			"The label displayed above the date input field in the date-time form field editor. The placeholder {label} is substituted with the field's configured label text.",
	},
	datePlaceholder: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.edit.date-placeholder',
		description: 'Placeholder for the date input field when no date is selected',
		defaultMessage: 'e.g. {date}',
	},
	timeLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.edit.time-label',
		defaultMessage: 'Time : {label}',
		description:
			"The label displayed above the time input field in the date-time form field editor. The placeholder {label} is substituted with the field's configured label text.",
	},
	timePlaceholder: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.edit.time-placeholder',
		description: 'Placeholder for the time input field when no time is selected',
		defaultMessage: 'e.g. {time}',
	},
});
